export const MembershipRole = {
  ANNOTATOR: 'annotator',
  MEMBER: 'member',
  ADMIN: 'admin',
  OWNER: 'owner',
  WORKFORCE_MANAGER: 'workforce_manager',
} as const

export type MembershipRole = (typeof MembershipRole)[keyof typeof MembershipRole]
